import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//   const routes = [
//     {
//       path: '/',
//       name: 'basicLayout',
//       component: () => import('../basicLayout/index.vue'),
//       redirect:'/home',
//       children:[
        
//       ]
//     },
//     {
//       path: '/home',
//       name: 'home',
//       component: () => import('../pages/home.vue'),
//     },
//     {
//       path: '/productManage',
//       name: 'productManage',
//       component: () => import('../pages/productManage.vue'),
//     },
//     {
//       path: '/detail',
//       name: 'detail',
//       component: () => import('../pages/detail.vue'),
//     }
// ]

const router = new VueRouter({
  // routes
})

router.beforeEach((to, from, next) => {
  // 让页面回到顶部
  document.documentElement.scrollTop = 0
  // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
   next()
})
export default router
